import { useNavigate } from 'react-router-dom';
import IconDuplicate from '../../../../../components/icons/icon-duplicate/icon-duplicate';
import { ButtonIcon } from '../../../../../components/inputs/button-icon/button-icon';

interface CopyPlanButtonProps {
    children?: React.ReactNode;
    planId: number;
}

const CopyPlanButton: React.FC<CopyPlanButtonProps> = ({ planId }) => {
    let navigate = useNavigate();
    const handleClick = () => {
        navigate({
            pathname: 'new',
            search: `?copy_from_id=${planId}`,
        });
    }
    return (
        <ButtonIcon Component={IconDuplicate} onClick={handleClick} />
    );
};

export default CopyPlanButton;
